import React, {
	useState
} from "react";
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { useTheme } from '@mui/material/styles';
import { useSpring, animated } from '@react-spring/web'
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate, } from "react-router-dom";


function PorjectsList (props){

	let navigate = useNavigate();
  const theme = useTheme();
	const mobile = useMediaQuery('(max-width:1000px)');

  function ProjectCard(cardProps){
    const [hovered, setHover] = useState(false)
    const AnimatedBox = animated(Box);

    const { opacity } = useSpring({
      
      opacity: (hovered ? 0.75: 0.0),
      config: {
        duration: 300
      },
  
    })

    const { opacityText } = useSpring({
      
      opacityText: (hovered ? 1.0: 0.0),
      config: {
        duration: 150
      },
  
    })

    function Redirect() {
      if(cardProps.redirect) navigate(cardProps.redirect);
    }
    
    
    return(
      <Button
        href={cardProps.href?cardProps.href:''}
        style={{
          backgroundColor:"transparent"
        }}
        onClick={Redirect}
      >
        <Card 
          onPointerOver={() => setHover(true)}
          onPointerLeave={() => setHover(false)}
          sx={{ 

            mb:mobile?3:0,
            backgroundColor:theme.palette.quaternary.main,
            borderRadius: 5,
            outline:`solid ${hovered ? `4px` : `0px` }` ,
            outlineColor: theme.palette.tertiary.main,
          }}
          style={{
            cursor:hovered ? 'pointer' : 'auto',
            backgroundImage: `url(${cardProps.image})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center bottom',
            width:mobile?'80vw':'450px',
            height:mobile?'80vw':'450px'
          }}
        >
          <AnimatedBox
            sx={{
              width:mobile?'80vw':'450px',
              height:mobile?'80vw':'450px',
              display:'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            style={{
              backgroundColor:theme.palette.secondary.main,
              opacity:opacity,
              color:theme.palette.quaternary.main
            }}
          >
          </AnimatedBox>  
          <AnimatedBox
            style={{
              position: 'absolute',
              marginTop:mobile?"-200px":"-250px",
              width:mobile?'80vw':'450px',
              color:theme.palette.quaternary.main,
              opacity:opacityText,
            }}
          >
            <Typography textAlign="center" p={2} variant="h2"color={props.titleColor} component="div">{cardProps.title}</Typography>
          </AnimatedBox>
        </Card>
      </Button>
    )
  }
  return(
    <Grid
      container
      p={2}
    >
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: mobile?'column':'row',
          flexWrap:"wrap"
        }}
      >
        {props.data.map((data, index)=>
        <ProjectCard
          key={index}
          image={data.img}
          href={data.href}
          redirect={data.redirect}
          title={data.title}
        ></ProjectCard>)}
        
      </Grid>
    </Grid>
  )
}

export default PorjectsList;